// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"13":"211a0c3a","322":"0c62f38e","963":"7b4f3a91"}[chunkId] + ".chunk.css";
};